import { useQuery } from '@tanstack/react-query'

import { CustomEventTypesApi } from '@/services/networks/customEventTypesApi'

export interface BiddingCustomEvent {
  id: string
  name: string
}

/**
 * The custom events a dynamic bid strategy can optimise towards: the ones the
 * network settings allow, plus the one the line item already optimises for
 * when the network has since dropped it, so the saved goal still shows.
 */
export function useBiddingCustomEvents(allowedIds: string[], currentId?: string): BiddingCustomEvent[] {
  const ids = currentId && !allowedIds.includes(currentId) ? [...allowedIds, currentId] : allowedIds

  const { data: customEvents = [] } = useQuery({
    queryKey: ['custom-events', ''],
    queryFn: () => CustomEventTypesApi.getAll(),
    enabled: ids.length > 0,
    staleTime: 5 * 60 * 1000,
  })

  return ids.map((id) => ({ id, name: customEvents.find((e) => e.id === id)?.name ?? id }))
}
